const CONSENT_KEY = 'cookie-consent';

export function initCookieBanner(): void {
  // Check if user has already given consent
  if (localStorage.getItem(CONSENT_KEY)) {
    return;
  }

  // Create blocking overlay
  const overlay = document.createElement('div');
  overlay.className = 'cookie-banner__overlay';
  document.body.appendChild(overlay);

  // Create banner element
  const banner = document.createElement('div');
  banner.className = 'cookie-banner';
  
  const content = document.createElement('div');
  content.className = 'cookie-content';
  
  const text = document.createElement('div');
  text.className = 'cookie-text';
  text.textContent = 'Diese Website verwendet notwendige Cookies für Funktionalität und Sicherheit. Bitte klicken Sie auf "Akzeptieren", um der Nutzung zuzustimmen und fortzufahren. Weitere Informationen: ';
  
  const datenschutzLink = document.createElement('a');
  datenschutzLink.href = '/datenschutz.html';
  datenschutzLink.target = '_blank';
  datenschutzLink.textContent = 'Datenschutz';
  
  const separator = document.createTextNode(' | ');
  
  const impressumLink = document.createElement('a');
  impressumLink.href = '/impressum.html';
  impressumLink.target = '_blank';
  impressumLink.textContent = 'Impressum';
  
  const period = document.createTextNode('.');
  
  text.appendChild(datenschutzLink);
  text.appendChild(separator);
  text.appendChild(impressumLink);
  text.appendChild(period);
  
  const actions = document.createElement('div');
  actions.className = 'cookie-actions';
  
  const acceptBtn = document.createElement('button');
  acceptBtn.className = 'cookie-btn';
  acceptBtn.textContent = 'Akzeptieren';
  
  actions.appendChild(acceptBtn);
  content.appendChild(text);
  content.appendChild(actions);
  banner.appendChild(content);

  document.body.appendChild(banner);

  // Show banner with animation
  setTimeout(() => banner.classList.add('show'), 100);

  // Handle accept
  acceptBtn.addEventListener('click', () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    banner.classList.remove('show');
    overlay.classList.add('fade-out');
    setTimeout(() => {
      banner.remove();
      overlay.remove();
    }, 300);
  });
}
